<template>
  <div
    v-if="showBanner"
    class="cookie-consent"
    role="dialog"
    aria-live="polite"
    aria-label="Cookie consent"
  >
    <div class="cookie-consent-inner">
      <p class="cookie-text">
        We use only strictly necessary cookies to run this website. Read our
        <router-link to="/cookie-policy">Cookie Policy</router-link> and
        <router-link to="/privacy-policy">Privacy Policy</router-link> to learn more.
      </p>
      <div class="cookie-actions">
        <button class="cookie-btn cookie-btn-accept" @click="accept">Accept</button>
        <button class="cookie-btn cookie-btn-decline" @click="decline">Decline non-essential</button>
      </div>
    </div>
  </div>
</template>

<script>
const STORAGE_KEY = "ajonee_cookie_consent";

export default {
  name: "CookieConsent",
  data() {
    return {
      showBanner: false,
    };
  },
  mounted() {
    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      this.showBanner = !stored;
    } catch (e) {
      // localStorage unavailable (e.g. privacy mode) — don't block the page
      this.showBanner = false;
    }
  },
  methods: {
    accept() {
      this.setConsent("accepted");
    },
    decline() {
      this.setConsent("declined");
    },
    setConsent(value) {
      try {
        window.localStorage.setItem(STORAGE_KEY, value);
      } catch (e) {
        // ignore storage errors
      }
      this.showBanner = false;
    },
  },
};
</script>

<style scoped>
.cookie-consent {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 20000;
  background: var(--primary);
  color: #fff;
  padding: 1rem;
  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.15);
}
.cookie-consent-inner {
  max-width: 75rem;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}
.cookie-text {
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.5em;
  flex: 1 1 20rem;
}
.cookie-text a,
.cookie-text :deep(a) {
  color: #fff;
  text-decoration: underline;
  font-weight: 600;
}
.cookie-actions {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}
.cookie-btn {
  border: none;
  border-radius: 0.25rem;
  padding: 0.6rem 1.1rem;
  font-size: 0.9rem;
  font-weight: 700;
  cursor: pointer;
}
.cookie-btn-accept {
  background: var(--secondary);
  color: #fff;
}
.cookie-btn-decline {
  background: transparent;
  color: #fff;
  border: 1px solid #fff;
}
.cookie-btn:focus-visible {
  outline: 2px solid #fff;
  outline-offset: 2px;
}
</style>
